export const getPositionOnce = (timeoutMs = 6000) =>
  new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lon: p.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 60000 }
    );
  });

export const getPositionIfGranted = async (timeoutMs = 5000) => {
  try {
    if (navigator.permissions?.query) {
      const st = await navigator.permissions.query({ name: "geolocation" });
      if (st.state !== "granted") return null;
    }
  } catch {
    return null;
  }
  return getPositionOnce(timeoutMs);
};

export const isTripToday = (trip) => {
  const pad = (n) => String(n).padStart(2, "0");
  const now = new Date();
  const t = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  return (trip?.days || []).some((d) => d.date === t);
};

export const haversineKm = (a, b) => {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLon = ((b.lon - a.lon) * Math.PI) / 180;
  const s = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
};

export const buildRouteInfo = (route) => {
  const geometry = route?.geometry;
  if (!geometry || geometry.length < 2) return null;
  const cum = [0];
  for (let i = 1; i < geometry.length; i++) {
    cum.push(cum[i - 1] + haversineKm({ lat: geometry[i - 1][0], lon: geometry[i - 1][1] }, { lat: geometry[i][0], lon: geometry[i][1] }));
  }
  const ratio = route.distance_km ? cum[cum.length - 1] / route.distance_km : 1;
  return { geometry, cum, ratio };
};

export const dayWindow = (day, marginKm = 3) => {
  if (!day || day.route_start_km == null || !day.distance_km) return null;
  return { fromKm: Math.max(0, day.route_start_km - marginKm), toKm: day.route_start_km + day.distance_km + marginKm };
};

export const kmOnRoute = (info, pos, maxOffKm = 5, window = null) => {
  if (!info || !pos) return null;
  let best = -1;
  let bestD = Infinity;
  const step = Math.max(1, Math.floor(info.geometry.length / 1500));
  for (let i = 0; i < info.geometry.length; i += step) {
    if (window) {
      const km = info.cum[i] / info.ratio;
      if (km < window.fromKm || km > window.toKm) continue;
    }
    const d = haversineKm({ lat: info.geometry[i][0], lon: info.geometry[i][1] }, pos);
    if (d < bestD) { bestD = d; best = i; }
  }
  if (best < 0 || bestD > maxOffKm) return null;
  return info.cum[best] / info.ratio;
};
